<template>
  <Modal :title="isAddManage?'新建推广位':'编辑推广位'"
         v-model="modalVisible"
         class-name="vertical-center-modal">
    <div class="form-group">
      <div class="label-wrap">
        推广位名称
      </div>
      <div class="form-item-wrap">
        <input type="text"
               placeholder="请输入不超过16个字符的名称"
               v-model="app_name" />
      </div>
    </div>
    <div class="form-group" v-if="!isAddManage">
      <div class="label-wrap">
        APP_SECRET
      </div>
      <div class="form-item-wrap">
        <span v-model="app_secret" style="color: #999999;padding-right: 20px;">{{app_secret}}</span>
        <span class="reset" @click="reset">重置</span>
        <span class="copy" @click="copy">复制</span>
      </div>
    </div>

    <div class="form-group">
      <div class="label-wrap">
        备注
      </div>
      <div class="form-item-wrap">
        <textarea placeholder="添加推广位备注，以便更好地区分"
                  v-model="remark"></textarea>
      </div>
    </div>

    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn"
              @click="submitAddManage">确定</span>
        <span class="btn cancel-btn"
              @click="cancelSubmit">取消</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import { createPromotion,editPromotion,appSecretReset } from '@/api/promotion'
import { Modal } from 'view-design'
export default {
  name: "AddManage",
  components: {
    Modal
  },
  data: function () {
    return {
      isAddManage: true,
      modalVisible: false,
      id: '',
      app_name:'',
      remark:'',
      app_key:'',
      app_secret:'',
      loading:false,
    }
  },
  mounted: function () {
    this.isAddManage = true
    this.modalVisible = false
  },
  methods: {
    init: function (isAddManage, row) {
      console.log(row)
      this.isAddManage = isAddManage
      this.modalVisible = true
      if(!isAddManage){
        this.id = row.id
        this.app_name = row.app_name
        this.remark = row.remark
        this.app_key = row.app_key
        this.app_secret = row.app_secret
      }else{
        this.id = '';
        this.app_name = '';
        this.remark = '';
        this.app_key = '';
        this.app_secret = '';
      }
    },
    submitAddManage: function () {
      if(this.loading){
        return
      }
      this.loading = true;
      const loadingMessage = this.$Message.loading({
        content: '保存中...',
        duration: 0
      });
      if(this.isAddManage){
        createPromotion({
          app_name:this.app_name,
          remark:this.remark
        }).then(response => {
          this.modalVisible = false;
          this.$Message.success(response.msg)
          this.loading = false
          loadingMessage()
          this.$emit('refreshList');
        }).catch(error =>{
          this.loading = false
          loadingMessage()
          console.log(error)
        })
      }else{
        editPromotion({
          app_key:this.app_key,
          app_name:this.app_name,
          remark:this.remark
        }).then(response => {
          this.modalVisible = false;
          this.$Message.success(response.msg)
          loadingMessage()
          this.loading = false;
          this.$emit('refreshList');
        }).catch(error =>{
          this.loading = false;
          loadingMessage()
          console.log(error)
        })
      }
    },
    cancelSubmit: function () {
      this.modalVisible = false
    },
    copy: function () {
      var that = this
      this.$copyText(this.app_secret).then(function (e) {
        that.$Message.success('复制成功')
        console.log(e)
      }, function (e) {
        that.$Message.error('复制失败,请升级浏览器版本！')
        console.log(e)
      })
    },
    reset:function () {
      if(this.loading){
        return
      }
      this.loading = true;
      const loadingMessage = this.$Message.loading({
        content: '重置中...',
        duration: 0
      });
      appSecretReset({
        app_key:this.app_key
      }).then(response => {
        this.$Message.success(response.msg)
        this.app_secret = response.data.app_secret
        loadingMessage()
        this.loading = false;
        this.$emit('refreshList');
      }).catch(error =>{
        this.loading = false;
        loadingMessage()
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .vertical-center-modal .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  width: 100%;
  margin-bottom: 0.4rem;
}
.vertical-center-modal .form-group .label-wrap {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  width: 90px;
  text-align: right;
  margin-right: 0.32rem;
}
.vertical-center-modal .form-group .form-item-wrap {
  flex: 1;
  min-width: 0;
}
.vertical-center-modal .form-group .form-item-wrap input:focus {
  border: 1px solid #ff8622;
  border-radius: 2px;
}
.vertical-center-modal .form-group .form-item-wrap input {
  padding: 0.16rem 0.2rem;
  width: 100%;
  letter-spacing: 0;
  font-size: 14px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
}

.vertical-center-modal .form-group .form-item-wrap input:-ms-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.vertical-center-modal .form-group .form-item-wrap input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}

.vertical-center-modal
  .form-group
  .form-item-wrap
  input::-webkit-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}

.vertical-center-modal .form-group .form-item-wrap textarea {
  width: 100%;
  resize: none;
  padding: 11px 10px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  height: 1.76rem;
}
.vertical-center-modal .form-group .form-item-wrap textarea:focus {
  border: 1px solid #ff8622;
  border-radius: 2px;
}
/*textarea 的 place holder*/
.vertical-center-modal .form-group .form-item-wrap textarea::-moz-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.vertical-center-modal .form-group .form-item-wrap textarea::-moz-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.vertical-center-modal
  .form-group
  .form-item-wrap
  textarea::-webkit-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 12px 18px;
  text-align: right;
}

.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.footer-wrapper .btn {
  display: inline-block;
  border-radius: 2px;
  margin-right: 10px;
  padding: 0.12rem 0.68rem;
  font-size: 16px;
  cursor: pointer;
}
.footer-wrapper .btn.confirm-btn {
  background: #ff8622;
  color: #fff;
}
.footer-wrapper .btn.cancel-btn {
  background: #eeeeee;
  border-radius: 2px;
}
.form-item-wrap .reset{
  color: #FFFFFF;
  padding: 4px 10px;
  background: #199ED8;
  border-radius: 15px;
}
.form-item-wrap .copy{
  margin-left: 10px;
  color: #FF8622;
  padding: 3px 10px;
  border: 1px solid #FF8622;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/manage/modal/AddManage.vue